export const CLEAR_ADMIN_AUDIT_SEARCH = 'CLEAR_ADMIN_AUDIT_SEARCH';
export const SELECT_ADMIN_AUDIT_TAB = 'SELECT_ADMIN_AUDIT_TAB';

export const ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL = 'Tournaments';
export const ADMIN_AUDIT_TAB_CAPTAINS_LABEL = 'Captains';
export const ADMIN_AUDIT_TAB_TEAMS_LABEL = 'Teams';
export const ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL = 'Virtual Entries';
export const ADMIN_AUDIT_TAB_BOWLERS_LABEL = 'Bowlers';


// WEBPACK FOOTER //
// ./src/features/admin/audit/constants.js